import CreditReportGeneralAlert from './CreditReportGeneralAlert';
export default CreditReportGeneralAlert;
